"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable import/no-cycle */
var React = require("react");
var search_1 = require("@usereactify/search");
var instantSearchForm_1 = require("./instantSearchForm");
var SearchForm = /** @class */ (function (_super) {
    __extends(SearchForm, _super);
    function SearchForm(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        return _this;
    }
    SearchForm.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(search_1.ReactifySearchProvider, { mode: "instant-search", shopifyPermanentDomain: window.Shopify.shop },
                React.createElement(search_1.Sensors, null),
                React.createElement(instantSearchForm_1.InstantSearchForm, null))));
    };
    return SearchForm;
}(React.PureComponent));
exports.SearchForm = SearchForm;
